'use client'

import { m } from 'framer-motion'
import { usePathname } from 'next/navigation'

export default function Template({ children }: { children: React.ReactNode }) {
  const pathname = usePathname()

  const isProjectDetail = pathname?.startsWith('/projects/')

  return (
    <m.div
      initial={isProjectDetail ? { scale: 0.97 } : { y: 16 }}
      animate={isProjectDetail ? { scale: 1 } : { y: 0 }}
      exit={isProjectDetail ? { scale: 0.97 } : { y: -16 }}
      transition={{ duration: isProjectDetail ? 0.3 : 0.4, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </m.div>
  )
}
